import YellowVelvetTop from "./YellowVelvetTop.png"
import PinkCrochetTop from "./PinkCrochetTop.png"
import StripedTerryTop from "./StripedTerryTop.png"
import TexturedBlueTop from "./TexturedBlueTop.png"

let data_product = [
    {
        id:1,
        name: "Yellow Velvet Kini Top",
        image: YellowVelvetTop,
        price: 40.00,
    },

    {
        id:2,
        name: "Pink Crochet Kini Top",
        image: PinkCrochetTop,
        price: 40.00,
    },

    {
        id:3,
        name: "Striped Terry Kini Top",
        image: StripedTerryTop,
        price: 40.00,
    },

    {
        id:4,
        name: "Textured Blue Kini Top",
        image: TexturedBlueTop,
        price: 40.00,
    },
];

export default data_product;